
<div class="container-fluid disconnected-container d-flex flex-column">

  <div class="row disconnected-header justify-content-center align-items-center">
    <div class="col-12 text-center">
      <img src="assets/logo_qwintal.svg" alt="Logo" class="logo">
    </div>
  </div>


  <div class="row flex-grow-1 disconnected-main justify-content-center">
    <div class="col-md-6 col-lg-5 d-none d-md-flex login-visual-xl" style="min-height: 450px;">
      <div class="welcome-text">
        <h2 class="fira-sans-bold">Bienvenue</h2>
        <h3>L'appli Qwintal vous permet de centraliser et de piloter toutes les données de pesée de chaque animal.</h3>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-5 d-flex justify-content-center align-items-center">
      <div class="w-100 p-4" style="max-width: 400px; ">
        <form [formGroup]="loginForm">

          <div class="col-md-3 d-flex d-md-none login-visual-xs">
            <div class="welcome-text">
              <h2 class="fira-sans-bold">Bienvenue</h2>
              <h3>L'appli Qwintal vous permet de centraliser et de piloter toutes les données de pesée de chaque animal.</h3>
            </div>
          </div>
          <div class="mb-3 d-flex justify-content-center align-items-center">
            <nb-form-field>
              <nb-icon nbPrefix icon="q-utilisateur" pack="custom"></nb-icon>
              <input type="text" nbInput fullWidth shape="round" class="input-login" placeholder="Utilisateur" formControlName="email" required />
            </nb-form-field>
          </div>
          <div class="mb-4 d-flex justify-content-center align-items-center">
            <nb-form-field>
              <nb-icon nbPrefix icon="q-password" pack="custom"></nb-icon>
              <input [type]="showPassword ? 'text' : 'password'" nbInput fullWidth shape="round" class="input-login" placeholder="Mot de passe" formControlName="password" required />
              <button nbSuffix nbButton ghost (click)="showPassword = !showPassword" type="button" tabindex="-1">
                <nb-icon [icon]="showPassword ? 'eye-off-outline' : 'eye-outline'"></nb-icon>
              </button>
            </nb-form-field>
          </div>
          @if (error) {
            <div class="mb-2 d-flex justify-content-center align-items-center">
              <p class="error">Veuillez vérifier votre email et votre mot de passe.</p>
            </div>
          }
          <div class="form-group d-flex justify-content-center align-items-center">
            <button nbButton status="danger" shape="round" size="medium"  class="submit-disconnect"  (click)="loginAction()"
              title="Se connecter" >Se connecter<nb-icon icon="q-fleche-droite" pack="custom"></nb-icon></button>
            </div>
            <div class="form-group d-flex justify-content-center align-items-center">
              <a [routerLink]="['/auth', 'forgot']">Mot de passe oublié</a>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="row disconnected-footer justify-content-center align-items-center">
      <div class="col-12 text-center">
        Visitez notre site <a href="https://www.qwintal.fr" target="_blank">www.qwintal.fr</a>
      </div>
    </div>
  </div>
